import { useEffect, useMemo, useState } from "react";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";
import Accordion from "../../components/Accordion";
import Button from "../../components/Button";
import { ButtonBackgroundColorType } from "../../components/Button/Button";
import { BackgroundColor, Bankdiv, BSDiv, BsImg, BSpaymentDiv, ButtonContainer, ColAccNumb, ColReg, Container, DiscountCodeDiv, HelpText, InputRow, MobilepayDiv, MobilePayInfo, MobilepaySvg, PaymentName, PaymentoptionsDiv, Question, QuestionPaymentDuration, DiscountButton } from "./PaymentStep.style";
import { useStore } from "../../../../store/store";
import { PaymentFrequencyTypeEnum } from "../../../../types/PaymentFrequencyTypeEnum";
import InputVF from "../../components/InputVF";
import { InputTypeEnum } from "../../components/InputVF/InputVF";
import Reciept from "../../components/Reciept";
import { VisibleLayoutEnum } from "../../FormEnrollmentNew";
import Analytics from "../../../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../../../types/TrackingFlowTypeEnum";
import { fetchSignupDate, postEnrollment } from "../../../../utils/api";
import Modal from "../../components/Modal";
import { MobilepayImg } from "../../../TrackAndTrace/TrackAndTrace.styles";
import { PaymentTypeEnum } from "../../../../types/PaymentTypesEnum";
import { fetchDiscountStatus } from "../../../../utils/api";

interface Props {
  step2: AccordionRoutesEnum;
}





export default function PaymentStep({step2}: Props) {
  const t = useStore.useTranslations();
  const payload = useStore.usePayload();
  const setPayload = useStore.useSetPayload();
  const [regNumber, setRegNumber] = useState("");
  const [regNumberSucces, setRegNumberSucces] = useState(false);
  const [regNumberHasError, setRegNumberHasError] = useState(Boolean);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNumberSucces, setAccountNumberSucces] = useState(false);
  const [accountNumberHasError, setAccountNumberHasError] = useState(Boolean);
  const [showPaymentOptions, setShowPaymentOptions] = useState<boolean>();
  const [showBsPayment, setShowBsPayment] = useState<boolean>();
  const completedAccordionRoute = useStore.useAccordionRouteCompletedArray();
  const setCompletedAccordionRoute = useStore.useSetCompletedAccordionRoute();
  const setSwitchLayout = useStore.useSetSwitchLayout();
  const offerEnabled = useStore.useOfferEnabled();
  const fullAmountPayment = useStore.useFullAmountPayment();
  const setTrackAndTraceUrl = useStore.useSetTrackAndTraceUrl();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [discountCode, setDiscountCode] = useState("");
  const [showDiscount, setDiscountState] = useState(false);
  const showDiscountField = useStore.useDiscountCodesEnabled();
  const [discountValidated, setdiscountValidated] = useState<boolean>();
  const isDesktop = useStore.useIsDesktop();

  //Checks to show/hide Mobilepay as option and BS payment fields
  /*   useMemo(() => {
    payload.wantsUnion && !payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsurance && !payload.wantsSalaryInsuranceAndUnion ? setShowPaymentOptions(true) : setShowPaymentOptions(false);
    
    if(!showPaymentOptions) {
      setShowBsPayment(true);
    } else {
      if(payload.paymentType === PaymentTypeEnum.BSPAYMENT) {
        setShowBsPayment(true);
      } else {
        setShowBsPayment(false);
      }
    }
  }, [payload])  */

  useMemo(() => {
    if(payload.wantsUnion && !payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsuranceAndUnion){
      setShowPaymentOptions(true);
    } else if(!payload.wantsUnion && payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsuranceAndUnion){
      setShowPaymentOptions(true);
    } else {
      setShowPaymentOptions(false);
    }
    // payload.wantsUnion && !payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsuranceAndUnion ? setShowPaymentOptions(true) : setShowPaymentOptions(false);
    // !payload.wantsUnion && payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsuranceAndUnion ? setShowPaymentOptions(true) : setShowPaymentOptions(false);
  }, [payload.wantsUnion, payload.wantsUnemploymentBenefits, payload.wantsSalaryInsurance, payload.wantsSalaryInsuranceAndUnion]) 

  useMemo(() => {
    if (!showPaymentOptions) {
      setShowBsPayment(true);
      setPayload({ paymentType: PaymentTypeEnum.BSPAYMENT });
    } else if (showPaymentOptions) {
      setShowBsPayment(false);
      setPayload({ paymentType: PaymentTypeEnum.NONE });
    }
  }, [showPaymentOptions]);
  //end check to show/hide Mobilepay as option and BS payment fields

  const discountState = () => {
    setDiscountState(true);
  };

  const validateDiscount = async (discount: string) => {
    if (discount === "") return false;
    const response = (await fetchDiscountStatus(discountCode)).data;
    return response ? true : false;
    
  }

  const validationDiscount = useMemo(() => {
    if(discountCode !== undefined && discountCode !== ""){
      validateDiscount(discountCode).then((v) => {
        setdiscountValidated(v);
      });
    }
  }, [discountCode]);

  

  const validationRegNumb = useMemo(() => {
    if (regNumber !== undefined && regNumberHasError) {
      return false;
    } else if (regNumberSucces) {
      return true;
    }
  }, [regNumber, regNumberHasError, regNumberSucces]);

  const validationAccNumb = useMemo(() => {
    if (accountNumber !== undefined && accountNumberHasError) {
      return false;
    } else if (accountNumberSucces) {
      return true;
    }
  }, [accountNumber, accountNumberHasError]);

  const nextStepAllowed = useMemo(() => {
    if (discountValidated === false) {
      return false;
    }
    if (!showPaymentOptions) {
      if (payload.paymentFrequency && regNumber && accountNumber && !accountNumberHasError && !regNumberHasError) {
        return true;
      } else {
        return false;
      }
    } else {
      if (payload.paymentType === PaymentTypeEnum.BSPAYMENT) {
        if (payload.paymentFrequency && regNumber && accountNumber && !accountNumberHasError && !regNumberHasError) {
          return true;
        } else {
          return false;
        }
      } else if (payload.paymentType === PaymentTypeEnum.MOBILE_PAY) {
        return true;
      } else {
        return false;
      }
    }
  }, [regNumber, accountNumber, payload.paymentType, showPaymentOptions, discountValidated]);

  const paymentFrequencyMonthly = () => {
    setPayload({ paymentFrequency: PaymentFrequencyTypeEnum.Monthly });
    //tracking
    Analytics.getInstance().trackPaymentFrequency("monthly");
  };

  const paymentFrequencyQuarterly = () => {
    setPayload({ paymentFrequency: PaymentFrequencyTypeEnum.Quarterly });
    //tracking
    Analytics.getInstance().trackPaymentFrequency("quarterly");
  };

  //Trigger the function of onClick when pressing enter or space on a card
  const keyDownPaymentMobilepay = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event) {
      if (event && (event.key === "Enter" || event.key === " ")) {
        setPayload({ paymentType: PaymentTypeEnum.MOBILE_PAY });
      }
    }
  };

  const keyDownPaymentBS = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event) {
      if (event && (event.key === "Enter" || event.key === " ")) {
        setPayload({ paymentType: PaymentTypeEnum.BSPAYMENT });
      }
    }
  };

  return (
    <Accordion
      title={t?.paymentStep.title}
      step={AccordionRoutesEnum.PaymentStep}
      onNext={async () => {
        setIsFetching(true);
        setPayload({ discountCode: discountCode });
        setPayload({ regNo: regNumber });
        setPayload({ accountNo: accountNumber });

        const accountDetails = {
          regNo: regNumber,
          accountNo: accountNumber,
        };
        const response = await postEnrollment({
          ...payload,
          ...accountDetails,
        });

        if (response && response.data && response.data.url) {
          setTrackAndTraceUrl(response.data.url);

          // Add tracking
          //console.log("Tracking purchase with payload1:", fullAmountPayment);
          Analytics.getInstance().trackPurchase(payload, offerEnabled, fullAmountPayment, step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
          Analytics.getInstance().trackStepCount(completedAccordionRoute.length, step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);
          Analytics.getInstance().trackStep("ThankYouStep", step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical, payload);

          //Only track consent if at least one consent value is true
          const hasAnyConsent = Object.values(payload.consents ?? {}).some((consent) =>
            Object.values(consent ?? {}).some(Boolean)
          );
          if (hasAnyConsent) {
            Analytics.getInstance().trackAllConsent("collected", payload.consents, step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
          }

          setCompletedAccordionRoute(AccordionRoutesEnum.PaymentStep)
          setSwitchLayout(VisibleLayoutEnum.ThankYou)
          //window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        }
        setIsFetching(false);
      }}
      stepComplete={nextStepAllowed && !isFetching}
      previousStep={AccordionRoutesEnum.ConsentStep}
      headerImg="/assets/images/wallet-outline.svg"
      step2={step2}
    >
      <Container>
        {showPaymentOptions && (
          <>
            <Question>Vælg betalingsmetode</Question>
            <PaymentoptionsDiv>
              <div>
                <MobilepayDiv
                  onClick={() => {
                    setPayload({ paymentType: PaymentTypeEnum.MOBILE_PAY });
                    setShowBsPayment(false);
                  }}
                  selected={payload.paymentType === PaymentTypeEnum.MOBILE_PAY}
                  onKeyDown={(event) => keyDownPaymentMobilepay(event)}
                  tabIndex={0}
                >
                  <MobilepaySvg src="/assets/images/mobilepay.svg" />
                </MobilepayDiv>
                <PaymentName>MobilePay</PaymentName>
              </div>
              <div>
                <BSDiv
                  onClick={() => {
                    setPayload({ paymentType: PaymentTypeEnum.BSPAYMENT });
                    setShowBsPayment(true);
                  }}
                  selected={payload.paymentType === PaymentTypeEnum.BSPAYMENT}
                  onKeyDown={(event) => keyDownPaymentBS(event)}
                  tabIndex={0}
                >
                  <BsImg src="/assets/images/betalingsservice.png" />
                </BSDiv>
                <PaymentName>Betalingsservice</PaymentName>
              </div>
            </PaymentoptionsDiv>
            {payload.paymentType === PaymentTypeEnum.MOBILE_PAY && <MobilePayInfo>Du betaler automatisk hver måned via MobilePay.</MobilePayInfo>}
          </>
        )}
        {showBsPayment && (
          <BSpaymentDiv>
            <Question>{t?.paymentStep.description}</Question>
            <Bankdiv>
              <InputRow>
                <ColReg>
                  <InputVF
                    id="paymentstep_regNumb"
                    name="payStep_regNumb"
                    type={InputTypeEnum.text}
                    labelText="Reg nr."
                    placeholder="Reg. nr"
                    autocomplete="on"
                    onChange={(e) => {
                      setRegNumber(e.currentTarget.value);
                      const reg = /^[0-9]{4}$/;
                      if (!reg.test(e.currentTarget.value)) {
                        setRegNumberHasError(true);
                      } else if (reg.test(e.currentTarget.value)) {
                        setRegNumberHasError(false);
                        setRegNumberSucces(true);
                      }
                    }}
                    maxlength={4}
                    validated={validationRegNumb}
                    step={AccordionRoutesEnum.PaymentStep}
                  />
                </ColReg>
                <ColAccNumb>
                  <InputVF
                    id="paymentstep_AccountNumb"
                    name="payStep_AccNumb"
                    type={InputTypeEnum.text}
                    labelText="Kontonummer"
                    placeholder="Kontonummer"
                    autocomplete="on"
                    maxlength={10}
                    onChange={(e) => {
                      setAccountNumber(e.currentTarget.value);
                      const reg = /[0-9]{10}$/;
                      if (!reg.test(e.currentTarget.value)) {
                        setAccountNumberHasError(true);
                      } else if (reg.test(e.currentTarget.value)) {
                        setAccountNumberHasError(false);
                        setAccountNumberSucces(true);
                      }
                    }}
                    validated={validationAccNumb}
                    step={AccordionRoutesEnum.PaymentStep}
                  />
                </ColAccNumb>
              </InputRow>
              {payload.wantsSalaryInsuranceAndUnion && <HelpText>{t?.paymentStep.helpText}</HelpText>}
              {!payload.wantsSalaryInsuranceAndUnion && (
              <>
              <QuestionPaymentDuration>{t?.paymentStep.typeTitle}</QuestionPaymentDuration>
              <ButtonContainer>
                <Button bgColor={ButtonBackgroundColorType.Blue} blockButton={true} onClick={() => paymentFrequencyMonthly()} isChecked={payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly}>
                  {t?.paymentStep.monthly}
                </Button>
                <Button bgColor={ButtonBackgroundColorType.Blue} blockButton={true} onClick={() => paymentFrequencyQuarterly()} isChecked={payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly}>
                  {t?.paymentStep.quaterly}
                </Button>
              </ButtonContainer>
              </>
              )}
            </Bankdiv>
          </BSpaymentDiv>
        )}
        {payload.occupation === "SelfEmployed" && !showDiscount && showDiscountField && (
          <DiscountButton onClick={discountState}>Har du en rabatkode?</DiscountButton>
        )}
        {payload.occupation === "SelfEmployed" && (payload.wantsBasic || payload.wantsHRJura) && showDiscount && showDiscountField && (
          <BackgroundColor>
            <DiscountCodeDiv>
              <InputVF
                id="paymentstep_DiscountCode"
                name="payStep_DiscountCode"
                type={InputTypeEnum.text}
                labelText="Rabatkode"
                placeholder="Har du en rabatkode?"
                autocomplete="on"
                maxlength={20}
                onChange={(e) => {
                  setDiscountCode("");
                  setdiscountValidated(undefined);
                  setDiscountCode(e.currentTarget.value);
                  setPayload({ discountCode: e.currentTarget.value });
                }}
                validated={discountCode === "" ? undefined : discountValidated}
                step={AccordionRoutesEnum.PaymentStep}
              />
            </DiscountCodeDiv>
          </BackgroundColor>
        )}
        <Reciept info={showBsPayment ? `Din betaling tilknyttes Betalingsservice.` : `Din betaling tilknyttes MobilePay`} basePrice={false} hidden={isDesktop} />
      </Container>
      <Modal showModal={showErrorModal} modalText={t?.summaryStep.errorMessage ?? ""} modalBlock={false} onClose={() => setShowErrorModal(false)}></Modal>
    </Accordion>
  );
}